<template>
	<l-circle
		:lat-lng="latLng"
		:radius="radius"
		color="rgba(69, 69, 69, var(--tw-bg-opacity))"
		:fill-opacity="0.0"
	/>
</template>

<script>
import MapCenter from "./MapCenter.vue";

export default {
	mixins: [MapCenter],
	props: {
		distance: {
			required: true,
			type: Number,
			default: 150,
		},
		geo: {
			type: Object,
			required: false,
			default: null,
		},
	},
	computed: {
		radius() {
			return this.distance * 1000;
		},
	},
};
</script>
